import React, { useState } from 'react';

import { ScreenPrinting, SublimationPrint, UVPrint, VinlyPrint } from '../..';
import { LabeledInput, CheckBox } from '../../../Components';
import './index.css';

const Index = ({ types }) => {
    const [gst, setGST] = useState(5);
    const [width, setWidth] = useState(10);
    const [heigth, setHeight] = useState(10);
    const [isChestlogo, SetIsChestLogo] = useState(false);
    const [chestLogoPrice, setChestLogoPrice] = useState(50);
    const [minimumPrintCost, setMiniMumCost] = useState(85);
    const [pricePerInch, setPricePerInch] = useState(1);
    const [neckLabelPrice, setNeckLabelPrice] = useState(7);
    const [hasaNeckLabel, setNeckLabel] = useState(false);
    const [screenPrice, setScreenPrice] = useState(150);
    const [maxPrintHeight, setMaxPrintHeight] = useState(12);
    const [maxPrintWidth, setMaxPrintWidth] = useState(18);
    const [maxNeckLabelHeight, setMaxNeckLabelHeight] = useState(2.5);
    const [maxNeckLabelWidth, setMaxNeckLabelWidth] = useState(3);
    const materialCheckhandler = (name, currentState) => {
        SetIsChestLogo(!currentState);
    };
    const neckLabelCheckhandler = (name, currentState) => {
        setNeckLabel(!currentState);
    };
    const designPrice = isChestlogo ? chestLogoPrice : Math.max(minimumPrintCost, width * heigth * pricePerInch);
    let price = 150 + 50 + designPrice;
    if (hasaNeckLabel) {
        price += neckLabelPrice;
    }
    price += price * (gst / 100);
    return (
        <div className="pricing">
            <div className="pricing_head">
                <h2>Pricing</h2>
            </div>
            <div className="gst_div">
                <LabeledInput
                    style={{ width: '100%', maxWidth: '280px' }}
                    type="number"
                    label="GST (for all Printing Types)"
                    name="Width"
                    value={gst}
                    changeHandler={(e) => {
                        setGST(e.target.value);
                    }}
                />
                <button className="btn-orange">Update GST</button>
            </div>
            {types.findIndex((ele) => ele === 'Digital print design') !== -1 ? (
                <div className="pricing_body">
                    <div className="home_head">
                        <h2 className="home_heading"> Digital Print</h2>
                    </div>
                    <div>
                        <div>
                            <p>
                                <span>Tshirt Cost:</span> 150₹
                            </p>
                            <p>
                                <span>Delivery Cost:</span> 50₹
                            </p>
                            <p>
                                <span>Printing Type:</span> Digital Print
                            </p>
                            <p>
                                <span>Printing type Cost(Per inch Square):</span> {pricePerInch}₹
                                <p style={{ marginBottom: '2rem' }} className="input_info">
                                    Minimum Cost of Printing: {minimumPrintCost}₹
                                </p>
                            </p>
                            <LabeledInput
                                style={{ width: '100%', maxWidth: '280px' }}
                                disbale={isChestlogo}
                                type="number"
                                name="Width"
                                value={isChestlogo ? 0 : width}
                                changeHandler={(e) => {
                                    setWidth(e.target.value);
                                }}
                                label={`Design Width (in inches) - Max. ${maxPrintWidth} inches*`}
                            />
                            <LabeledInput
                                style={{ width: '100%', maxWidth: '280px' }}
                                disbale={isChestlogo}
                                type="number"
                                name="Height"
                                value={isChestlogo ? 0 : heigth}
                                changeHandler={(e) => {
                                    setHeight(e.target.value);
                                }}
                                label={`Design Height (in inches) - Max. ${maxPrintHeight} inches*`}
                            />
                            <CheckBox
                                style={{ marginBottom: '0' }}
                                handleChange={materialCheckhandler}
                                name="IsChestLogo"
                                value="IsChestLogo"
                                labeling="Is Chest Logo?"
                                checked={false}
                            />
                            <p style={{ marginBottom: '2rem' }} className="input_info">
                                Chest Logo has fix price {chestLogoPrice}₹
                            </p>
                            <CheckBox
                                style={{ marginBottom: '0' }}
                                handleChange={neckLabelCheckhandler}
                                name="isNeckLabel"
                                value="isNeckLabel"
                                labeling="has a Neck Label?"
                                checked={false}
                            />
                            <p style={{ marginBottom: '2rem' }} className="input_info">
                                Neck Label has fix price {neckLabelPrice}₹ (Maximum Dimension : {maxNeckLabelHeight}in X
                                {maxNeckLabelWidth}in)
                            </p>
                            <p>
                                <span>Total Price (inclusive of shipping and {gst}% GST):</span> {price}₹
                            </p>
                        </div>
                        <div>
                            <p>
                                <span>Set Pricing Values</span>
                            </p>
                            <LabeledInput
                                style={{ width: '100%', maxWidth: '280px' }}
                                type="number"
                                label="Print Cost(Per inch Sq.) ₹"
                                name="printcost"
                                value={pricePerInch}
                                changeHandler={(e) => {
                                    setPricePerInch(e.target.value);
                                }}
                            />
                            <LabeledInput
                                style={{ width: '100%', maxWidth: '280px' }}
                                type="number"
                                label="Minimum Print Cost ₹"
                                name="miniumcost"
                                value={minimumPrintCost}
                                changeHandler={(e) => {
                                    setMiniMumCost(e.target.value);
                                }}
                            />
                            <LabeledInput
                                style={{ width: '100%', maxWidth: '280px' }}
                                type="number"
                                label="Chest Logo Price ₹"
                                name="chestlogo"
                                value={chestLogoPrice}
                                changeHandler={(e) => {
                                    setChestLogoPrice(e.target.value);
                                }}
                            />
                            <LabeledInput
                                style={{ width: '100%', maxWidth: '280px' }}
                                type="number"
                                label="Neck Label Price ₹"
                                name="necklabel"
                                value={neckLabelPrice}
                                changeHandler={(e) => {
                                    setNeckLabelPrice(e.target.value);
                                }}
                            />
                            <LabeledInput
                                style={{ width: '100%', maxWidth: '280px' }}
                                type="number"
                                label="One Time Screen Price ₹"
                                name="Screen Price"
                                value={screenPrice}
                                changeHandler={(e) => {
                                    setScreenPrice(e.target.value);
                                }}
                            />
                            <div className="pricing_body_dimensions">
                                <p>Print Dimension Maximum Value:</p>
                                <div>
                                    <LabeledInput
                                        style={{ width: '100%', maxWidth: '280px' }}
                                        type="number"
                                        label="Width(inches):"
                                        name="widthprint"
                                        value={maxPrintHeight}
                                        changeHandler={(e) => {
                                            setMaxPrintHeight(e.target.value);
                                        }}
                                    />
                                    <LabeledInput
                                        style={{ width: '100%', maxWidth: '280px' }}
                                        type="number"
                                        label="Height(inches):"
                                        name="Heightprint"
                                        value={maxPrintWidth}
                                        changeHandler={(e) => {
                                            setMaxPrintWidth(e.target.value);
                                        }}
                                    />
                                </div>
                            </div>
                            <div className="pricing_body_dimensions">
                                <p>Neck Label Dimension Maximum Value:</p>
                                <div>
                                    <LabeledInput
                                        style={{ width: '100%', maxWidth: '280px' }}
                                        type="number"
                                        label="Width(inches):"
                                        name="widthlabel"
                                        value={maxNeckLabelHeight}
                                        changeHandler={(e) => {
                                            setMaxNeckLabelHeight(e.target.value);
                                        }}
                                    />
                                    <LabeledInput
                                        style={{ width: '100%', maxWidth: '280px' }}
                                        type="number"
                                        label="Height(inches):"
                                        name="Heightlabel"
                                        value={maxNeckLabelWidth}
                                        changeHandler={(e) => {
                                            setMaxNeckLabelWidth(e.target.value);
                                        }}
                                    />
                                </div>
                            </div>
                            <button className="btn-orange">Update Values</button>
                        </div>
                    </div>
                </div>
            ) : (
                <></>
            )}
            {types.findIndex((ele) => ele === 'Screen Print Design') !== -1 ? <ScreenPrinting gst={gst} /> : <></>}
            {types.findIndex((ele) => ele === 'Sublimation Print Design') !== -1 ? (
                <SublimationPrint gst={gst} />
            ) : (
                <></>
            )}
            {types.findIndex((ele) => ele === 'UV printing') !== -1 ? <UVPrint gst={gst} /> : <></>}
            {types.findIndex((ele) => ele === 'Vinyl Printing') !== -1 ? <VinlyPrint gst={gst} /> : <></>}
        </div>
    );
};

export default Index;
